import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { loadUsersList, loadUsersListPublic } from '../api/users';
import { fetchAPI } from '../utils/api';
import { message } from 'antd';
import { FIVE_MINUTES } from '../constants/CONSTANTS';

/**
 *
 * @param user user object on redux, state.user
 * @returns
 */
export const useSAUsers = (user?: AppState['user']) => {
  const reduxUser = useSelector((state: AppState) => state.user);
  const users = useQuery<{
    list: Array<{
      id: number;
      full_name: string;
      username: string;
    }>;
    system_user_id: number;
    loading?: boolean;
  }>({
    queryKey: ['users'],
    queryFn: async () => {
      return loadUsersList(user || reduxUser);
    },
    staleTime: 10 * 60 * 1000,
    placeholderData: {
      list: [],
      system_user_id: null,
      loading: true,
    },
    refetchOnWindowFocus: false,
  });

  return users;
};

export const useUserRegions = () => {
  const user = useSelector((state: AppState) => state.user);

  return user?.regions || [];
};

export const useSAUsersPublic = () => {
  const users = useQuery<
    Array<{ id: number; username: string; full_name: string }>
  >(
    ['sa-users-public-all'],
    async () => {
      try {
        const resp = await loadUsersListPublic();

        return resp;
      } catch (error) {
        return [];
      }
    },
    {
      staleTime: 10 * 60 * 1000,
      placeholderData: [],
    }
  );

  return users;
};

export const useSAUserRegions = (userId: number) => {
  const user = useSelector((state: AppState) => state.user);
  const regions = useQuery<{
    loading: boolean;
    list: string[];
  }>(
    ['user-regions', userId, user?.id],
    async () => {
      if (!userId || userId === user?.id) {
        return {
          loading: false,
          list: (user?.regions || []).sort(),
        };
      }

      try {
        const resp = await fetchAPI('user/regions', {
          payload: {
            user_id: userId,
          },
        });

        return { loading: false, list: (resp.regions || []).sort() };
      } catch (error) {
        message.error('Failed get user regions [01]');
        return {
          loading: false,
          list: [],
        };
      }
    },
    {
      staleTime: FIVE_MINUTES,
      placeholderData: {
        loading: true,
        list: [],
      },
    }
  );

  return regions;
};
